<template>
    <BasePopUp v-if="showModal" @detailsClosed="onCancel">
        <div class="modal-body-container">
            <h4 class="text-center mt-4">{{ message }}</h4>
            <div class="d-flex justify-content-center mb-4 button-group">
                <CButton type="button" class="btn btn-primary" @click="onConfirm">{{ confirmText }}</CButton>
                <CButton type="button" class="btn btn-secondary" @click="onCancel">{{ cancelText }}</CButton>
            </div>
        </div>
    </BasePopUp>
</template>

<script>
import BasePopUp from './BasePopUp.vue';

export default {
    components: { BasePopUp },
    model: {
        prop: 'showModal',
        event: 'showModalChanged'
    },
    methods: {
        onConfirm() {
            this.$emit("choiceConfirm");
        },
        onCancel() {
            this.$emit("choiceCancel");
        }
    },
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        message: {
            type: String,
            default: ''
        },
        confirmText: {
            type: String,
            default: 'Ok'
        },
        cancelText: {
            type: String,
            default: 'Cancel'
        },
    },
}
</script>

<style scoped>
    .modal-body-container
    {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px;
        border-radius: 10px;
        min-height: 200px;
    }

    .button-group
    {
        gap: 12px;
    }
</style>
